<template>
  <div>
    <div class="head"
         :style='`width:${width.hole};height:${height.head}`'>
      <img src="../../../assets/imgs/top_title_bg.png"
           alt=""
           class="headImg"
           :style="`top:${-23*$store.state.ratio.hole}px;`">
      <div class="head-item"></div>
      <div class="head-item"
           :style="`font-size:${28*$store.state.ratio.hole}px;line-height:${70*$store.state.ratio.hole}px;padding-left:${20*$store.state.ratio.hole}px`">扶贫数据中心</div>
      <div class="head-item">
        <img src="../../../assets/imgs/closeLock.png"
             @click="carousel()"
             :style="`width:${30*$store.state.ratio.width}px;height:${24*$store.state.ratio.height}px`"
             v-if='$store.state.lock' />
        <img src="../../../assets/imgs/openLock.png"
             @click="carousel()"
             :style="`width:${30*$store.state.ratio.width}px;height:${24*$store.state.ratio.height}px`"
             v-if='!$store.state.lock' />
      </div>
    </div>
    <div :style='`width:${width.hole};height:${height.hole}`'
         class="flex">
      <div class='chart'
           :style='`height:${height.hole}`'>
        <card :width='width.card'
              :height="height.card"
              name='扶贫类型分布'
              class="margin mgb">
          <pie :data='data.poorType'
               v-if="data.poorType&&data.poorType.length" />

        </card>
        <card :width='width.card'
              :height="height.card"
              name='各乡镇扶贫人口'
              class="margin mgb">
          <progressChart :width='width.card'
                         :height="height.slot"
                         :series='data.mapNumber' />

        </card>
        <card :width='width.card'
              :height="height.card"
              name='扶贫产品'
              class="margin">
          <barDiagram :barData='data.product'
                      v-if="data.product.length" />

        </card>
      </div>
      <div class='chart flexed'
           :style='`height:${height.hole}`'>
        <div class="border-top flex"
             :style='`height:${110*$store.state.ratio.height}px`'>
          <div class="chart fitem">
            <div class="mid-top wh"
                 :style='`font-size:${14*$store.state.ratio.hole}px;`'>扶贫总人数</div>
            <poverty-num-show :data='data.totalHelpMan.value'
                 v-if='data.totalHelpMan.value'
                 :style='`margin-bottom:${10*$store.state.ratio.hole}px`' >
                 </poverty-num-show>
                  </div>
          <div class="chart fitem">
            <div class="mid-top wh"
                 :style='`font-size:${14*$store.state.ratio.hole}px;`'>扶贫总金额</div>
                   <poverty-num-show :data='String(data.totalHelpAmount.value)'
                 v-if='data.totalHelpAmount.value'
                 :style='`margin-bottom:${10*$store.state.ratio.hole}px`' ></poverty-num-show>
            <!-- <div class="bradius cb"
                 :style='`font-size:${14*$store.state.ratio.hole}px;width:${120*$store.state.ratio.width}px;height:${80*$store.state.ratio.width}px;line-height:${80*$store.state.ratio.width}px`'>{{data.totalHelpAmount.value}}</div> -->
          </div>

        </div>

        <!-- <div class="mid-top"
             :style='`font-size:${20*$store.state.ratio.hole}px`'>扶贫总人数:{{data.TotalHelpMan.value}}</div>

        <div class="mid-top"
             :style='`font-size:${20*$store.state.ratio.hole}px`'>扶贫总金额:{{data.TotalHelpAmount.value}}</div> -->
        <div :style='`height:${600*$store.state.ratio.hole}px;width:100%`'>
          <!-- 各地区扶贫人口分布图 -->
         <!-- <yinjiangMap :data='data.mapNumber'
                       v-if="data.mapNumber.length" />  -->
         <!-- <tongxinMap v-if="data.mapNumber.length"  :data='data.mapNumber' />  -->
         <map-components v-if="data.mapNumber.length"  :data='data.mapNumber'></map-components>
        </div>

      </div>
      <div class='chart'
           :style='`height:${height.hole}`'>
        <card :width='width.card'
              :height="height.card"
              name="扶贫户家庭分析"
              class="margin mgb">
          <el-table :data="data.helpPeople"
                    :height="height.slot"
                    width='100%'
                    :style="`font-size:${12*$store.state.ratio.hole}px`">
            <el-table-column v-for="(item,index) in tableProp"
                             :key='index'
                             :prop="item.prop"
                             :label="item.label"
                             :width="item.width"
                             align='center'>
            </el-table-column>
          </el-table>
        </card>
        <card :width='width.card'
              :height="height.card"
              name="扶贫户金额"
              class="margin mgb">
          <barDiagram :barData='data.helpAmount'
                      v-if="data.helpAmount.length" />
        </card>
        <card :width='width.card'
              :height="height.card"
              name='各民族扶贫人口占比'
              class="margin">
          <!-- <div class="flex">
            <div class="chart border"
                 :style="`height:${parseFloat(height.slot)/2}px;`"
                 v-for="(item,index) in data.img1"
                 :key="index">
              <img :src="item"
                   alt="">
            </div>

          </div>
          <div class="flex">
            <div class="chart border"
                 :style="`height:${parseFloat(height.slot)/2}px`"
                 v-for="(item,index) in data.img2"
                 :key="index">
              <img :src="item"
                   alt="">
            </div>
          </div> -->

          <doughnut :data='data.national'
                    v-if="data.national&&data.national.length" />

        </card>
      </div>
    </div>
  </div>

</template>
<script>
var first = true;
import card from "../../../components/common/card.vue";
import povertyNumShow from "../../../components/common/povertyNumShow.vue";
import api from "../api";
import setting from "../setting";
import Swiper from "swiper";
// import yinjiangMap from '../components/yinjiangMap.vue'
import mapComponents from '../components/mapComponents.vue'
import tongxinMap from "../components/tongxinMap.vue";
import "swiper/dist/css/swiper.min.css";
export default {
  components: {
    card,
    tongxinMap,
    povertyNumShow,
    mapComponents
    // yinjiangMap
  },
  data() {
    return {
      width: {
        hole: "",
        card: "",
      },
      height: {
        hole: "",
        card: "",
        head: "",
        slot: "",
      },
      tableProp: [
        {
          prop: "name",
          label: "户名",
          width: 100 * this.$store.state.ratio.width + "px",
        },
        { prop: "town", label: "区域" },
        { prop: "amount", label: "扶贫金额" },
      ],
      data: {
        poorType: [],
        national: [],
        totalHelpMan: {},
        helpAmount: [],
        product: [],
        mapNumber: [],
        helpPeople: [],
        totalHelpAmount: {},
      },
      lock: true,
      marginLeft:"",
      options: {
        nested: true,
        loop: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination-v",
        },
        autoplay: 2000,
      },
    };
  },
  created() {
    let self = this;
    const width = document.body.clientWidth;
    const height = document.body.clientHeight;
    this.width.hole = width + "px";
    this.getHeadHeight(height);
    this.height.hole = height - parseFloat(this.height.head) + "px";
    this.getcardWidth(width, height);
    this.getdata();
    let interval = setInterval(self.getdata, setting.requestTime);
    interval;
  },
  methods: {
    getcardWidth(width, height) {
      this.width.card = (width - 4) / 4 - 6 + "px";
      this.height.card =
        (height - parseFloat(this.height.head) - 2) / 3 - 30 + "px";
      this.height.slot = parseFloat(this.height.card) * 0.9 + "px";
    },
    getHeadHeight(height) {
      this.height.head = 0.1 * height + "px";
    },
    carousel() {
      this.$store.commit("setLock");
      this.$emit("carousel");
    },
    getdata() {
      api.getPovrety().then((res) => {
        this.data.national = [];
        setTimeout(() => {
          this.data = res;
        }, 0);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  display: flex;
  position: relative;
  .headImg {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .head-item {
    flex: 1;
    text-align: center;
    position: relative;
    line-height: 50px;
    font-size: 18px;
    img {
      position: absolute;
      top: 35%;
      right: 3%;
    }
  }
}
.flex {
  display: flex;
  .chart {
    flex: 1;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .flexed {
    flex: 2;
    .mid-top {
      text-align: center;
      margin-top: 8%;
    }
  }
  .margin {
    margin-top: 0%;
  }
  .mgb {
    margin-bottom: 5%;
  }
}
.border {
  border: 1px solid black;
}
.border-top {
  width: 88%;
  position: relative;
  left: 10%;
  border: 1px solid blue;
}
.fitem {
  height: 100%;
  position: relative;
  .bradius {
    border-radius: 50%;
    background: #f7713b;
    text-align: center;
    color: yellow;
    position: relative;
    left: 30%;
    top: 5%;
  }
  .cb {
    background: #00f3ef;
  }
  .cy {
    color: yellow;
  }
  .wh{
    color: #ffffff;
  }
}
</style>
